import { Store } from '@ngrx/store';

import { NotificationActionTypes } from '../state/notification.actions';

import { FeatureCommandHandlerAdapter } from '@core/infrastructure/features/command-handler.adapter';
import { NotificationCommandProps } from '@features/notification/domain/models/notification.models';

export const NotificationCommands = {
    OPEN_NOTIFICATION: NotificationActionTypes.OPEN_NOTIFICATION,
};

export class NotificationCommand extends FeatureCommandHandlerAdapter<NotificationCommandProps> {
    constructor(public store: Store) {
        super(store);
    }
}
